import { render, staticRenderFns } from "./CategoryFooter.vue?vue&type=template&id=8d8c961a&"
import script from "./CategoryFooter.vue?vue&type=script&lang=js&"
export * from "./CategoryFooter.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFooter.vue?vue&type=style&index=0&id=8d8c961a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports